import environment from "web/script/modules/environment";
import { registerEvent } from "web/redux/ducks/event-count-tracker";
import browser from "web/script/utils/browser";
import store from "web/redux/store";

const EVENT_COUNTER_CATEGORIES = [
    "feed",
    "navigation",
    "product area",
    "product_card",
    "feeds_show_more",
    "sort_by",
    "filter",
];

export default {
    send(data) {
        const blockVariant = environment.getFeature("mg_block_on_event_counter");
        data.forEach((event) => {
            if (event.type !== "event" || event.data.page_type !== "feed" || !browser.ios) {
                return Promise.resolve();
            }
            if (
                EVENT_COUNTER_CATEGORIES.includes(event.data.category) &&
                (blockVariant === "hard_block" || blockVariant === "soft_block")
            ) {
                // for filter count the event on "filter open" only
                // otherwise for any action in the EVENT_COUNTER_CATEGORIES
                if (
                    event.data.category !== "filter" ||
                    (event.data.category === "filter" && event.data.action === "open")
                ) {
                    store.dispatch(
                        registerEvent({ category: event.data.category, action: event.data.action })
                    );
                }
            } else if (
                event.data.category === "app_overlay" &&
                event.data.action === "modal_dismissed" &&
                event.data.label === "event_counter_block"
            ) {
                // listening to the dismissal of the modal for soft_block
                store.dispatch(
                    registerEvent({ category: event.data.category, action: event.data.action })
                );
            }
        });
        // no way of waiting for this to be done
        return Promise.resolve();
    },
};
